import React, { useState } from "react";
import { FilterProps } from "@usereactify/search";
import { chevronDown } from "../../react-hooks/svgIcons";

export type FilterListProps = React.ComponentProps<
    NonNullable<FilterProps["renderFilterList"]>
>;

export const FilterList: React.FC<FilterListProps> = (props) => {
    return (
        <div className="rs__filter">
            {props.filter.displayView === "list" ? (
                <AccordionSection filterName={props.filter.name}>
                    <FilterListList {...props} />
                </AccordionSection>
            ) : null}
            {props.filter.displayType === "single" &&
                props.filter.displayView === "check" ? (
                <AccordionSection filterName={props.filter.name}>
                    <FilterListRadio {...props} />
                </AccordionSection>
            ) : null}
            {props.filter.displayType === "multi" &&
                props.filter.displayView === "check" ? (
                <AccordionSection filterName={props.filter.name}>
                    <FilterListCheckbox {...props} />
                </AccordionSection>
            ) : null}
            {props.filter.displayView === "swatch" ? (
                <AccordionSection filterName={props.filter.name}>
                    <FilterListSwatch {...props} />
                </AccordionSection>
            ) : null}
            {props.filter.displayView === "box" ? (
                <AccordionSection filterName={props.filter.name}>
                    <FilterListBox {...props} />
                </AccordionSection>
            ) : null}
        </div>
    );
};

const AccordionSection: React.FC<{ filterName: string; children: React.ReactNode }> = ({ filterName, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="accordion-section">
            <button
                className="accordion-button flex justify-between uppercase"
                onClick={() => setIsOpen(!isOpen)}
            >
                {filterName}
                <span>{chevronDown}</span>
            </button>
            <div className={`accordion-content ${isOpen ? "open" : ""}`}>
                {children}
            </div>
        </div>
    );
};

export const FilterListList: React.FC<FilterListProps> = (props) => {
    return (
        <ul className="rs__filter__list">
            {props.filterListProps.options.map((option) => (
                <li
                    key={option.key}
                    className={`rs__filter__list-item ${option.checked ? "rs__filter__list-item-active" : ""
                        }`}
                >
                    <label
                        className="rs__filter__list-item-label"
                        onClick={() => props.filterListProps.handleChange(option.key)}
                    >
                        <span className="rs__filter__list-item-key">{option.label}</span>
                    </label>
                </li>
            ))}
        </ul>
    );
};

export const FilterListRadio: React.FC<FilterListProps> = (props) => {
    return (
        <ul className="rs__filter__list">
            {props.filterListProps.options.map((option) => (
                <li
                    key={option.key}
                    className={`rs__filter__list-item ${option.checked ? "rs__filter__list-item-active" : ""
                        }`}
                >
                    <label className="rs__filter__list-item-label">
                        <input
                            className="rs__filter__list-item-input"
                            value={option.key}
                            type="radio"
                            checked={option.checked}
                            onChange={(event) =>
                                props.filterListProps.handleChange(event.target.value)
                            }
                        />
                        <span className="rs__filter__list-item-key">{option.label}</span>
                    </label>
                </li>
            ))}
        </ul>
    );
};

export const FilterListCheckbox: React.FC<FilterListProps> = (props) => {
    return (
        <ul className="rs__filter__list">
            {props.filterListProps.options.map((option) => (
                <li
                    key={option.key}
                    className={`rs__filter__list-item ${option.checked ? "rs__filter__list-item-active" : ""
                        }`}
                >
                    <label className="rs__filter__list-item-label flex">
                        <input
                            className="rs__filter__list-item-input"
                            value={option.key}
                            type="checkbox"
                            checked={option.checked}
                            onChange={(event) =>
                                props.filterListProps.handleChange(event.target.value)
                            }
                        />
                        <span className="rs__filter__list-item-key">{option.label}</span>
                    </label>
                </li>
            ))}
        </ul>
    );
};

export const FilterListSwatch: React.FC<FilterListProps> = (props) => {
    return (
        <div
            className="rs__filter__list flex flex-wrap"
        >
            {props.filterListProps.options.map((option) => (
                <div
                    key={option.key}
                    className={`rs__filter__list-item ${option.checked ? "rs__filter__list-item-active" : ""
                        }`}
                >
                    <div
                        className="rs__filter__list-item-label "
                        style={{
                            display: "inline-block",
                            width: "20px",
                            height: "20px",
                            marginRight: "2px",
                            marginBottom: "2px",
                            borderRadius: "50%",
                            backgroundColor: option.key,
                            border: option.checked
                                ? "1px solid black"
                                : "1px solid transparent",
                        }}
                        onClick={() => props.filterListProps.handleChange(option.key)}
                    />
                </div>
            ))}
        </div>
    );
};

export const FilterListBox: React.FC<FilterListProps> = (props) => {
    return (
        <div
            className="rs__filter__list flex flex-wrap"
        >
            {props.filterListProps.options.map((option) => (
                <div
                    key={option.key}
                    className={`rs__filter__list-item ${option.checked ? "rs__filter__list-item-active" : ""
                        }`}
                >
                    <div
                        className="rs__filter__list-item-label flex justify-center items-center"
                        style={{
                            width: "40px",
                            height: "40px",
                            marginRight: "2px",
                            marginBottom: "2px",
                            border: "1px solid black",
                            overflow: "hidden",
                            cursor: "pointer",
                            color: option.checked ? "white" : "black",
                            backgroundColor: option.checked ? "black" : "white",
                        }}
                        onClick={() => props.filterListProps.handleChange(option.key)}
                    >
                        {option.key}
                    </div>
                </div>
            ))}
        </div>
    );
};
